import { WordmarkIntro } from "./wordmark-intro";

export function Splash({
  subtitle,
  onDone,
  replay,
}: {
  subtitle?: string;
  onDone?: () => void;
  replay?: boolean;
}) {
  return (
    <main className="mx-auto flex min-h-svh max-w-md flex-col items-center justify-center gap-6 px-6 text-center">
      <WordmarkIntro onDone={onDone} replay={replay} />
      {subtitle ? (
        <p className="text-sm text-ink-3 num">{subtitle}</p>
      ) : null}
    </main>
  );
}
